import React from 'react'
import SaveSearchButton from './SaveSearchButton/SaveSearchButton'
import PropTypes from 'prop-types'
import RefreshPageButton from './RefreshPageButton/RefreshPageButton'
// import searchContext from '../FiltersComponent/context/context'
// import SearchSavedSearch from '../HeadBar/SearchSavedSearch/SearchSavedSearch'

const HeadBar = props => {
  const { view } = props
  // const { selectedMenu } = useContext(searchContext)

  return (
    <>
      <div className="w-full grid grid-cols-1 md:grid-cols-3 items-center p-4">
        <div className="md:col-span-1 overflow-hidden ">
          Create Property List
        </div>
        <div className="md:col-span-1 overflow-hidden ">
          {/* {selectedMenu !== 'search' ?
            <div className="flex flex-row items-center text-base ">
              <SearchSavedSearch></SearchSavedSearch>
            </div>
            : null} */}
        </div>
        <div className="md:col-span-1 flex justify-end space-x-4 overflow-hidden">
          <RefreshPageButton />
          <div className={`${view === 'search' ? 'float-right' : 'hide'}`}>
            <SaveSearchButton />
          </div>
        </div>
      </div>
    </>
  )
}

HeadBar.propTypes = {
  view: PropTypes.string
}

export default HeadBar
